export default {
  create: {
    method: 'post',
    url: '/client/quote/quote-request'
  },
  createAndRequestPrice: {
    method: 'post',
    url: '/client/quote/quote-request/request-price'
  },
  get: {
    method: 'post',
    url: '/client/quote/quote-request/list'
  },
  getDetail: {
    method: 'get',
    url: '/client/quote/quote-request/ID'
  },
  edit: {
    method: 'put',
    url: '/client/quote/quote-request/ID'
  },
  delete: {
    method: 'delete',
    url: '/client/quote/quote-request'
  },
  archive: {
    method: 'delete',
    url: '/client/quote/quote-request/archive'
  },
  restore: {
    method: 'put',
    url: '/client/quote/quote-request/restore'
  },
  viewTimeComplete: {
    method: 'get',
    url: '/client/quote/quote-request/view-time-complete/IDBUSINESSOPPORTUNITY'
  },
  find: {
    method: 'get',
    url: '/client/quote/quote-request/find?key=KEY'
  },
  requestPrice: {
    method: 'post',
    url: '/client/quote/quote-request/request-price/ID'
  },
  tollStation: {
    method: 'post',
    url: '/client/quote/quote-request/toll-station'
  },
  routingConnection: {
    method: 'post',
    url: '/client/quote/quote-request/routing-connection'
  }
}
